import React from "react";

interface TopBarProps {
  onMakeVideoClick: () => void;
}

const TopBar: React.FC<TopBarProps> = ({ onMakeVideoClick }) => {
  return (
    <div className="w-full bg-black dark:bg-black text-white px-6 py-1.5 sm:py-[7px] border-b border-white/30 transition-colors duration-300">
      <div className="w-full flex items-center justify-between min-h-full">
        {/* Logo - pushed all the way left */}
        <div className="flex items-center space-x-1.5 h-full">
          <img
            src="/pixelmaker_logo.svg"
            alt="Pixelmaker.ai"
            className="h-4 w-4 filter brightness-0 invert"
          />
          <h1 className="text-sm font-bold tracking-tight text-white">
            Pixelmaker.ai
          </h1>
        </div>

        {/* Center Text */}
        <div className="hidden sm:flex items-center justify-center flex-1 px-4 h-full">
          <p className="text-sm font-medium text-center text-white">
            Our videos have surpassed 2B views
          </p>
        </div>

        {/* Make Video Button / Center Text on Mobile */}
        <div className="flex items-center gap-3">
          {/* Mobile: Show center text */}
          <div className="sm:hidden">
            <p className="text-[13px] font-medium text-white text-right">
              Our videos have surpassed 2B views
            </p>
          </div>
          {/* Desktop: Show Make Video button */}
          <button
            onClick={onMakeVideoClick}
            className="hidden sm:block bg-transparent text-white border border-white hover:bg-white hover:text-black px-2 py-1 rounded-xl font-medium text-[10px] transition-all duration-200"
          >
            Make a Video
          </button>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
